import warning from 'warning';
import isObject from 'is-object';

function hasStore(duck, action, type) {
    let check;

    switch (type) {
        case 'array':
            check = Array.isArray(action.payload);
            break;
        case 'boolean':
            check = typeof action.payload === 'boolean';
            break;
        case 'number':
            check = typeof action.payload === 'number';
            break;
        case 'object':
            check = isObject(action.payload);
            break;
        case 'string':
            check = typeof action.payload === 'string';
            break;
    }

    warning(
        check,
        `
            The duck providing state at '${
                duck.path
            }' is trying to set it's local state but the ${
            action.type
        } action does not have a '${type}' payload.
            Instead a payload of ${typeof action.payload} was provided with a value of ${
            action.payload
        }.
        `
    );
}

export { hasStore as default };
